import React from 'react';

const websiteUrl = process.env.CLIENT_MAIN_WEBSITE_URL;

const Footer = () => {
	const date = new Date();
	return (
		<footer className="portal-footer py-3">
			<div className="container-fluid">
				<div
					className="text-center pb-3"
				>
					©
					{' '}
					{date.getFullYear()}
					{' '}
					Buddy Technology, Inc. All Rights
					Reserved
				</div>
				<div className="d-flex justify-content-center">
					<a className="white-inline-link mr-3" href={`${websiteUrl}/terms`}>
						Terms of Service
					</a>
					<a className="white-inline-link" href={`${websiteUrl}/privacy`}>
						Privacy Policy
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
